var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
/**
  * @function evalute - evaluate pipeBendOptionsBehavior
  */

const evaluate = async (source, content) => {
  const _content$identifier = content.identifier,
    identifier = _content$identifier === void 0 ? '?' : _content$identifier,
    _content$bends = content.bends,
    bends = _content$bends === void 0 ? {} : _content$bends;
  const result = {};
  const keys = Object.keys(bends);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const _bends$key = bends[key],
      _created = _bends$key._created,
      _bends$key$bendType = _bends$key.bendType,
      bendType = _bends$key$bendType === void 0 ? {
        any: {}
      } : _bends$key$bendType,
      _bends$key$angle = _bends$key.angle,
      angle = _bends$key$angle === void 0 ? '?' : _bends$key$angle;
    const _Object$values = Object.values(bendType),
      _Object$values2 = _slicedToArray(_Object$values, 1),
      _Object$values2$0$tit = _Object$values2[0].title,
      title = _Object$values2$0$tit === void 0 ? '?' : _Object$values2$0$tit;
    result[key] = {
      _created,
      title: "".concat(identifier, "-").concat(title, "-").concat(angle)
    };
  }
  return result;
};
module.exports = {
  evaluate
};